const PKCE_STORAGE_KEY = 'crm-sso-pkce-session'

export interface PkceSession {
  verifier: string
  state: string
  accountId: string
  tenantId: string
  clientId: string
  redirectUri: string
  scope: string
  silent?: boolean
  returnPath?: string
}

function base64UrlEncode(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function generateCodeVerifier(): string {
  const array = new Uint8Array(32)
  crypto.getRandomValues(array)
  return base64UrlEncode(array.buffer)
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
  const data = new TextEncoder().encode(verifier)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return base64UrlEncode(digest)
}

export function generateState(): string {
  const array = new Uint8Array(16)
  crypto.getRandomValues(array)
  return base64UrlEncode(array.buffer)
}

export function storePkceSession(session: PkceSession): void {
  sessionStorage.setItem(PKCE_STORAGE_KEY, JSON.stringify(session))
}

export function loadAndClearPkceSession(expectedState: string): PkceSession {
  const raw = sessionStorage.getItem(PKCE_STORAGE_KEY)
  sessionStorage.removeItem(PKCE_STORAGE_KEY)

  if (!raw) {
    throw new Error('SSO session expired. Please sign in again.')
  }

  const session = JSON.parse(raw) as PkceSession
  if (session.state !== expectedState) {
    throw new Error('Invalid SSO state. Please sign in again.')
  }

  return session
}

export function clearPkceSession(): void {
  sessionStorage.removeItem(PKCE_STORAGE_KEY)
}
